import { createFileRoute } from '@tanstack/react-router'
import { LandCommitmentTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/land-commitment-tab'
import { useStoreProjectModalTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/modal-tab-context'

export const Route = createFileRoute(
  '/_authenticated/development/real-estate/kanban/$cardId/land-commitment',
)({
  component: LandCommitmentTabRoute,
})

function LandCommitmentTabRoute() {
  const tab = useStoreProjectModalTab()
  return (
    <LandCommitmentTab
      form={tab.form}
      canEdit={tab.canEdit}
      onAutoDateModeChange={tab.handleAutoDateModeChange}
    />
  )
}
